export default <LinkWithIcon[]>[
  {
    label: 'Facebook',
    url: 'https://www.facebook.com/ongehoord',
    icon: 'bx:bxl-facebook',
  },
  {
    label: 'Instagram',
    url: 'https://www.instagram.com/ongehoordnl',
    icon: 'bx:bxl-instagram',
  },
  {
    label: 'X/Twitter',
    url: 'https://x.com/ongehoordnl',
    icon: 'bx:bxl-twitter',
  },
]
